<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="iconfont icon-shezhi"></i> 设置中心 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-tabs v-model="activeName" type="border-card">
                <el-tab-pane label="后台管理系统设置" name="first">
                    <CardBox mTitle="主题色设置">
                        <template v-slot:content>
                            <el-form class="mapElFrom" label-width="100px">
                                <el-form-item label="选择主题颜色">
                                    <el-color-picker v-model="themeColor"></el-color-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="defaultThemeColor">恢复默认</el-button>
                                    <el-button type="primary" @click="saveThemeColor">保存设置</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </CardBox>
                    <CardBox mTitle="首页地图设置">
                        <template v-slot:content>
                            <div class="settingMapBoxSystem">
                                <div class="left">
                                    <el-form class="mapElFrom" label-width="100px">
                                        <el-form-item label="地图中心点">
                                            <el-input v-model="homeMapForm.centerLocation"></el-input>
                                        </el-form-item>
                                        <el-form-item label="初始显示层级">
                                            <el-input v-model="homeMapForm.zIndex"></el-input>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button @click="defaultHomeMap">恢复默认</el-button>
                                            <el-button type="primary" @click="saveHomeMap">保存设置</el-button>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <div class="right">
                                    <div class="mapBox" id="homeMapSetting"></div>
                                </div>
                            </div>
                        </template>
                    </CardBox>
                </el-tab-pane>
                <el-tab-pane label="大屏界面设置" name="second">
                    <CardBox mTitle="主题色设置">
                        <template v-slot:content>
                            <el-form class="mapElFrom" label-width="100px">
                                <el-form-item label="选择主题颜色">
                                    <el-color-picker v-model="maxThemeColor"></el-color-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="defaultMaxThemeColor">恢复默认</el-button>
                                    <el-button type="primary" @click="saveMaxThemeColor">保存设置</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </CardBox>

                    <CardBox mTitle="标题文字设置">
                        <template v-slot:content>
                            <el-form class="mapElFrom" label-width="100px">
                                <el-form-item label="标题文字">
                                    <el-input placeholder="标题文字不易过长" v-model="maxTitle"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="defaultMaxTitle">恢复默认</el-button>
                                    <el-button type="primary" @click="saveMaxTitle">保存设置</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </CardBox>

                    <CardBox mTitle="地图默认定位标记点类型选择">
                        <template v-slot:content>
                            <el-form class="mapElFrom" label-width="100px">
                                <el-form-item label="选择类型">
                                    <el-tooltip class="item" effect="dark" content="根据设备的在线状态进行地图标记点显示,共有三种状态:正常/故障/维护"
                                        placement="bottom">
                                        <el-radio v-model="maxMarkerType" :label="1">在线状态</el-radio>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="根据设备的报警状态进行地图标记点显示,共有两种状态:报警/正常"
                                        placement="bottom">
                                        <el-radio v-model="maxMarkerType" :label="-1">报警状态</el-radio>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="defaultMaxMarkerType">恢复默认</el-button>
                                    <el-button type="primary" @click="saveMaxMarkerType">保存设置</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </CardBox>

                    <CardBox mTitle="大屏界面地图设置">
                        <template v-slot:content>
                            <div class="settingMapBoxSystem">
                                <div class="left">
                                    <el-form class="mapElFrom" label-width="100px">
                                        <el-form-item label="地图中心点">
                                            <el-input v-model="maxMapForm.centerLocation"></el-input>
                                        </el-form-item>
                                        <el-form-item label="初始显示层级">
                                            <el-input v-model="maxMapForm.zIndex"></el-input>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button @click="defaultMaxMap">恢复默认</el-button>
                                            <el-button type="primary" @click="saveMaxMap">保存设置</el-button>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <div class="right">
                                    <div class="mapBox" id="maxMapSetting"></div>
                                </div>
                            </div>
                        </template>
                    </CardBox>
                </el-tab-pane>
                <el-tab-pane label="账号设置" name="third">
                    <CardBox mTitle="修改密码">
                        <template v-slot:content>
                            <el-form class="mapElFrom" label-width="100px">
                                <el-form-item label="修改密码">
                                    <el-button type="primary" @click="openDialog">修改密码</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </CardBox>
                </el-tab-pane>
            </el-tabs>
        </div>

        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="400px">
            <el-form>
                <el-form-item label="原密码" label-width="120px">
                    <el-input class="inputWidth" v-model="changePwdForm.oldPwd" type="password"
                        :show-password="true"></el-input>
                </el-form-item>
                <el-form-item label="新密码" label-width="120px">
                    <el-input class="inputWidth" v-model="changePwdForm.newPwd1" type="password"
                        :show-password="true"></el-input>
                </el-form-item>
                <el-form-item label="新密码" label-width="120px">
                    <el-input class="inputWidth" v-model="changePwdForm.newPwd2" type="password"
                        :show-password="true"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveChangePwd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CardBox from '../common/cardBox';
import { ChangeUserPwd } from '../../api';
export default {
    data() {
        return {
            // 修改密码表单数据
            changePwdForm: {
                oldPwd: '',
                newPwd1: '',
                newPwd2: ''
            },
            // 打开修改密码界面
            dialogFormVisible: false,
            // 大屏默认标记点类型
            maxMarkerType: this.$store.state.maxMarkerType * 1,
            // 大屏标题
            maxTitle: this.$store.state.maxTitle,
            // 大屏主题颜色
            maxThemeColor: this.$store.state.maxThemeColor,
            // 首页地图
            mapContle: '',
            // 默认选中标签卡
            activeName: 'first',
            // 选择主题颜色
            themeColor: this.$store.state.themeColor,
            // 首页地图设置
            homeMapForm: {
                centerLocation: `${this.$store.state.homeMapSetting.Lng},${this.$store.state.homeMapSetting.Lat}`,
                zIndex: this.$store.state.homeMapSetting.zIndex
            },
            // 大屏地图设置
            maxMapForm: {
                centerLocation: `${this.$store.state.maxMapSetting.Lng},${this.$store.state.maxMapSetting.Lat}`,
                zIndex: this.$store.state.maxMapSetting.zIndex
            }
        };
    },
    components: {
        CardBox
    },
    mounted() {
        console.log(this.$store.state);
        this.changePadding();
        this.BMap();
        this.BmaxMap();
    },
    methods: {
        // 确定修改密码
        async saveChangePwd() {
            // 判断输入是否为空
            let { oldPwd, newPwd1, newPwd2 } = this.changePwdForm;
            oldPwd = oldPwd.trim();
            newPwd1 = newPwd1.trim();
            newPwd2 = newPwd2.trim();
            if (oldPwd == '' || newPwd1 == '' || newPwd2 == '') {
                this.$message.warning('请检查输入');
                return;
            }
            if (newPwd1 !== newPwd2) {
                this.$message.warning('请检查输入');
                return;
            }
            let that = this;

            this.$confirm('确认修改密码吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    console.log('既然怒');
                    const result = await ChangeUserPwd({ id: JSON.parse(localStorage.getItem('userinfo')).id, password: newPwd2, oldPwd: oldPwd });
                    console.log(result);
                    if (result.code !== 200) {
                        return;
                    }
                    that.$message.success('修改成功');
                    localStorage.clear();
                    that.$router.push('login');
                })
                .catch((err) => {
                    console.log(err);
                });

            console.log(oldPwd, newPwd1, newPwd2);
        },
        // 打开修改密码弹窗
        openDialog() {
            this.dialogFormVisible = true;
        },
        // 首页地图初始化
        BMap() {
            let that = this;
            var map = this.buildMap(
                'homeMapSetting',
                this.$store.state.homeMapSetting.Lng * 1,
                this.$store.state.homeMapSetting.Lat * 1,
                this.$store.state.homeMapSetting.zIndex * 1,
                'a625b4f8a2a68848323269086a5f4fef'
            );

            this.mapContle = map;
            // 添加地图中心点控件
            this.setCustomControlClass(map, BMAP_ANCHOR_TOP_RIGHT, 225, 125, require('@/assets/mapCenter.png'), '', function (e) {
                // 点击控件回调函数
            });
            // 添加监听地图变化函数
            map.addEventListener('moveend', function (e) {
                // 获取地图中心点以及缩放层级
                setTimeout(() => {
                    that.homeMapForm.centerLocation = map.getCenter().lng + ',' + map.getCenter().lat;
                    that.homeMapForm.zIndex = map.getZoom();
                }, 500);
            });
            // 监听地图缩放层级变化
            map.addEventListener('zoomend', function (e) {
                // 获取地图中心点以及缩放层级
                setTimeout(() => {
                    that.homeMapForm.centerLocation = map.getCenter().lng + ',' + map.getCenter().lat;
                    that.homeMapForm.zIndex = map.getZoom();
                }, 500);
            });
        },
        // 保存首页地图设置
        saveHomeMap() {
            let obj = {
                Lng: this.homeMapForm.centerLocation.split(',')[0],
                Lat: this.homeMapForm.centerLocation.split(',')[1],
                zIndex: this.homeMapForm.zIndex
            };
            this.$store.commit('setHomeMapSetting', obj);

            localStorage.setItem('homeMapSetting', JSON.stringify(obj));
            console.log(this.$store.state.homeMapSetting);
            console.log(localStorage.getItem('homeMapSetting'));
            this.$message.success('设置成功');
        },
        // 恢复默认首页地图
        defaultHomeMap() {
            let obj = {
                Lng: 116.403838,
                Lat: 39.914658,
                zIndex: 15
            };
            this.$store.commit('setHomeMapSetting', obj);
            localStorage.setItem('homeMapSetting', JSON.stringify(obj));
            var point = new BMapGL.Point(116.403838, 39.914658);
            this.mapContle.flyTo(point, 15);
            this.$message.success('设置成功');
        },

        // 保存大屏地图设置
        saveMaxMap() {
            let obj = {
                Lng: this.maxMapForm.centerLocation.split(',')[0],
                Lat: this.maxMapForm.centerLocation.split(',')[1],
                zIndex: this.maxMapForm.zIndex
            };
            this.$store.commit('setMaxMapSetting', obj);

            localStorage.setItem('maxMapSetting', JSON.stringify(obj));
            console.log(this.$store.state.maxMapSetting);
            console.log(localStorage.getItem('maxMapSetting'));
            this.$message.success('设置成功');
        },
        // 恢复默认大屏地图
        defaultMaxMap() {
            let obj = {
                Lng: 116.403838,
                Lat: 39.914658,
                zIndex: 15
            };
            this.$store.commit('setMaxMapSetting', obj);
            localStorage.setItem('maxMapSetting', JSON.stringify(obj));
            var point = new BMapGL.Point(116.403838, 39.914658);
            this.mapContle.flyTo(point, 15);
            this.$message.success('设置成功');
        },
        // 大屏地图初始化
        BmaxMap() {
            let that = this;
            var map = this.buildMap(
                'maxMapSetting',
                this.$store.state.maxMapSetting.Lng * 1,
                this.$store.state.maxMapSetting.Lat * 1,
                this.$store.state.maxMapSetting.zIndex * 1,
                'a625b4f8a2a68848323269086a5f4fef'
            );

            this.mapContle = map;
            // 添加地图中心点控件
            this.setCustomControlClass(map, BMAP_ANCHOR_TOP_RIGHT, 225, 125, require('@/assets/mapCenter.png'), '', function (e) {
                // 点击控件回调函数
            });
            // 添加监听地图变化函数
            map.addEventListener('moveend', function (e) {
                // 获取地图中心点以及缩放层级
                setTimeout(() => {
                    that.maxMapForm.centerLocation = map.getCenter().lng + ',' + map.getCenter().lat;
                    that.maxMapForm.zIndex = map.getZoom();
                }, 500);
            });
            // 监听地图缩放层级变化
            map.addEventListener('zoomend', function (e) {
                // 获取地图中心点以及缩放层级
                setTimeout(() => {
                    that.maxMapForm.centerLocation = map.getCenter().lng + ',' + map.getCenter().lat;
                    that.maxMapForm.zIndex = map.getZoom();
                }, 500);
            });
        },
        // 构建大屏地图
        buildMaxMap(dom, lat, lng, zoom, styleId) {
            var map = new BMapGL.Map(dom);
            var point = new BMapGL.Point(lat, lng);
            map.centerAndZoom(point, zoom);
            map.enableScrollWheelZoom(true);
            return map;
        },

        // 自定义增加地图控件
        setCustomControlClass(map, defaultAnchor, defaultOffsetWidth, defaultOffsetHeight, imgSrc, title, domOpts) {
            // 定义一个地图重置控件类
            function ResetMapControl() {
                // 默认停靠位置和偏移量
                this.defaultAnchor = defaultAnchor;
                this.defaultOffset = new BMapGL.Size(defaultOffsetWidth, defaultOffsetHeight);
            }
            // 通过JavaScript的prototype属性继承于BMap.Control
            ResetMapControl.prototype = new BMapGL.Control();
            // 自定义控件必须实现自己的initialize方法,并且将控件的DOM元素返回
            // 在本方法中创建个div元素作为控件的容器,并将其添加到地图容器中
            ResetMapControl.prototype.initialize = function (map) {
                // 创建一个DOM元素
                let div1 = document.createElement('img');
                // 设置样式
                div1.style.height = '50px';
                div1.style.width = '50px';
                div1.src = imgSrc;
                div1.style.backgroundColor = 'transparent';
                div1.style.padding = '3px';
                div1.style.boxSizing = 'border-box';
                div1.title = title;
                // 绑定事件
                div1.onclick = domOpts;
                // 添加DOM元素到地图中
                map.getContainer().appendChild(div1);
                // 将DOM元素返回
                return div1;
            };
            // 创建控件
            let resetMapCtrl = new ResetMapControl();
            // 添加到地图当中
            map.addControl(resetMapCtrl);
        },
        // 构建地图
        buildMap(dom, lat, lng, zoom, styleId) {
            var map = new BMapGL.Map(dom);
            var point = new BMapGL.Point(lat, lng);
            map.centerAndZoom(point, zoom);
            map.enableScrollWheelZoom(true);
            return map;
        },

        // 保存主题颜色
        saveThemeColor() {
            console.log(this.themeColor);
            this.$store.commit('setThemeColor', this.themeColor);
            localStorage.setItem('themeColor', this.themeColor);
            this.$message.success('设置成功');
        },
        // 恢复默认主题色
        defaultThemeColor() {
            this.themeColor = '#242f42';
            this.$store.commit('setThemeColor', this.themeColor);
            localStorage.setItem('themeColor', this.themeColor);
            this.$message.success('设置成功');
        },
        // 保存大屏主题颜色
        saveMaxThemeColor() {
            this.$store.commit('setMaxThemeColor', this.maxThemeColor);
            localStorage.setItem('maxThemeColor', this.maxThemeColor);
            this.$message.success('设置成功');
        },
        // 恢复大屏默认主题色
        defaultMaxThemeColor() {
            this.maxThemeColor = '#15c9cb';
            this.$store.commit('setMaxThemeColor', this.maxThemeColor);
            localStorage.setItem('maxThemeColor', this.maxThemeColor);
            this.$message.success('设置成功');
        },
        // 保存大屏标题文字
        saveMaxTitle() {
            this.$store.commit('setMaxTitle', this.maxTitle);
            localStorage.setItem('maxTitle', this.maxTitle);
            this.$message.success('设置成功');
        },
        // 恢复大屏默认标题文字
        defaultMaxTitle() {
            this.maxTitle = '智慧城市监测系统';
            this.$store.commit('setMaxTitle', this.maxTitle);
            localStorage.setItem('maxTitle', this.maxTitle);
            this.$message.success('设置成功');
        },
        // 保存大屏默认标记点类型
        saveMaxMarkerType() {
            this.$store.commit('setMaxMarkerType', this.maxMarkerType);
            localStorage.setItem('maxMarkerType', this.maxMarkerType);
            this.$message.success('设置成功');
        },
        // 恢复大屏默认标记点类型
        defaultMaxMarkerType() {
            this.maxMarkerType = 1;
            this.$store.commit('setMaxMarkerType', this.maxMarkerType);
            localStorage.setItem('maxMarkerType', this.maxMarkerType);
            this.$message.success('设置成功');
        },

        // 设置间隔
        changePadding() {
            let dom = document.querySelectorAll('.el-tabs__nav-scroll');
            console.log(dom);
            for (let index = 0; index < dom.length; index++) {
                dom[index].style = 'font-size:16px !important;';
                console.log(dom[index]);
            }
        }
        // handleClick(tab, event) {
        //     console.log(tab, event);
        // }
    }
};
</script>

<style lang="less" scoped>
.settingMapBoxSystem {
    display: flex;
    align-items: center;
    height: 300px;

    .right {
        .mapBox {
            width: 500px;
            height: 300px;
            margin-left: 50px;
        }
    }
}

.inputWidth {
    width: 200px;
}
</style>